import Heading from './Heading';

// export types
export type { HeadingProps } from './Heading';

// export components
export { Heading };
export default Heading;
